import z from 'zod'

export enum GetStorageListOrder {
  DATE = 'DATE',
  SIZE = 'SIZE'
}

export enum GetStorageListOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export const GetStorageListPropsSchema = z.object({
  filter: z.object({
    name: z.string().nullish(),
    date: z.object({
      start: z.string().max(10).nullish(),
      end: z.string().max(10).nullish()
    }).optional()
  }).optional(),
  order: z.object({
    by: z.nativeEnum(GetStorageListOrder).default(GetStorageListOrder.DATE),
    direction: z.nativeEnum(GetStorageListOrderDirection).default(GetStorageListOrderDirection.DESC)
  }),
  page: z.number().min(1).default(1),
  limit: z.number().min(1).max(500).default(10)
})

export type GetStorageListPropsSchemaType = z.infer<typeof GetStorageListPropsSchema>;
